import { render, staticRenderFns } from "./SelectPaymentType.vue?vue&type=template&id=7f87482c&"
import script from "./SelectPaymentType.vue?vue&type=script&lang=js&"
export * from "./SelectPaymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports